import React, { createContext, useContext } from "react";

const GridContext = createContext();

export const useGrid = () => useContext(GridContext);

export const GridProvider = ({ children, value }) => {
  return <GridContext.Provider value={value}>{children}</GridContext.Provider>;
};
